
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { FormulaTesterComponent, Variable } from '../../formula-tester/formula-tester.component';

@Component({
    selector: 'grid-color-configuration',
    templateUrl: './grid-color-configuration.component.html',
    styleUrls: ['./grid-color-configuration.component.scss'],
    standalone: false
})
export class GridColorConfigurationComponent implements OnInit {

  constructor(
    private http:HTTPService, 
    private spinner:NgxSpinnerService,
    private snackBar:SnackbarService,
    private dialogServices:DialogService,
    public uas:UserAuthenticationServices,
    @Inject(MAT_DIALOG_DATA) public data, 
    public dialogRef:MatDialogRef<any>
  ) { }

  codecompany;
  codecontract;
  sub3:Subscription;
  @Input() entityName:string;
  @Input() prefName:string;
  @Input() row:Object;
  formulastr;
  variables:Variable[] = [];
  internalid;
  
  ngOnInit(): void {
      this.formulastr = this.data.gridColor;
  }

  cancelEdit(){

  }

  printHelp(){
      this.formulastr = `if (params.node.rowIndex % 2 === 0) {
    return { background: 'red' };
}
if ( params.data.STATUS == "1" ) {
  return { background: '#8B0000' };
}`
  }

  close(){
    this.dialogRef.close(this.formulastr);
  }

}
